import { constants } from '../constants/calendar.constants';
import  moment  from 'moment';

const defaultState = {
	requests: [],
	workers: [],
	range: {},
	dataFetching: false
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case constants.SET_WORKER_CHECKED +'_FULFILLED': {
			return {
				...state,
				workers: action.payload.r,
				dataFetching: false,
			}
		}
		case constants.FETCH_REQUESTS + '_FULFILLED': {
			return {
				...state,
				requests: action.payload.events,
				workers: action.payload.resources,
				range: action.payload.range,
				dataFetching: false
			}
		}
		case constants.SET_WORKER_CHECKED +'_PENDING':
		case constants.FETCH_REQUESTS + '_PENDING': {
			return {
				...state,
				dataFetching: true
			}
		}
		case constants.SET_WORKER_CHECKED +'_REJECTED':
		case constants.FETCH_REQUESTS +'_REJECTED': {
				return {
				...state,
				dataFetching: false,
				apiResponseError: (action.payload.response && action.payload.response.status) || action.payload,
				apiResponseText: action.payload.response && action.payload.response.statusText
			}
		}
		default:
			return state;
	}
}